import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, CardDeck, Button, Modal } from "react-bootstrap";
import { getEGWorkedAcres, updateFieldWorkStatus } from "../../../actions/dashboard";
import EgCard from "./EgCard";
import { getDateRangeInfo } from "../../../actions/analyze";
import { WORK_TYPE_LIST, WORK_TYPE_COLOURS, HARVESTING_WORK_TYPE_ID, COMPLETED_WORK_STATUS, ACTIVE_WORK_STATUS } from "../../../constants";

const CardBody = (props) => {
  const { showDropdown, shapeRefId, isCompleted } = props;
  const dispatch = useDispatch();
  const farmId = useSelector((state) => state.dashboard.farmId);
  const planPlannedToDate = useSelector((state) => (farmId && state.analyze.searchParams.plannedTodate[farmId] ? state.analyze.searchParams.plannedTodate[farmId] : null));
  const egWorkedById = useSelector((state) => state.dashboard.field.egWorkedById);
  const selectedWorkTypeIds = useSelector((state) => state.dashboard.field.selectedWorkTypeIds);
  const egWorkDetails = [];
  for (const id in egWorkedById) {
    if (id.split("_")[0] === shapeRefId && selectedWorkTypeIds.indexOf(parseInt(id.split("_")[1])) >= 0) egWorkDetails.push(egWorkedById[id]);
  }
  const fieldListById = useSelector((state) => state.dashboard.field.fieldListById.payload);
  const egListById = useSelector((state) => state.dashboard.field.egListById.payload);
  const isRequestingEg = useSelector((state) => state.dashboard.field.egListById.isRequesting);
  const isRequestingWorkInfo = useSelector((state) => state.dashboard.field.workedAcresById.isRequesting);
  const isRequestingPlanPlannedToDate = planPlannedToDate ? planPlannedToDate.isRequesting : false;
  const { rangeId } = useSelector((state) => state.analyze.searchParams);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);

  const [complete, setComplete] = useState(false);
  const [currentFieldName, setCurrentFieldName] = useState(null);
  const [fieldWorkStatus, setFieldWorkStatus] = useState({
    workstatus: null,
    farmUuid: null,
    workTypeId: null,
    geoRegionShapeUuid: null,
    geoShapeUuid: null,
  });

  const handleFieldWorkStatus = () => {
    const params = {
      farm_uuid: farmId,
      work_status: [
        {
          geo_shape_uuid: fieldWorkStatus.geoShapeUuid,
          geo_region_shape_uuid: fieldWorkStatus.geoRegionShapeUuid,
          work_status: fieldWorkStatus.workstatus,
          work_type_id: fieldWorkStatus.workTypeId,
        },
      ],
    };

    dispatch(updateFieldWorkStatus(params));
  };

  const updateStatus = (isCompleted) => {
    setComplete(!complete);
    setCurrentFieldName(fieldListById[shapeRefId].geo_shape_name);
    setFieldWorkStatus({
      ...fieldWorkStatus,
      workstatus: isCompleted ? COMPLETED_WORK_STATUS : ACTIVE_WORK_STATUS,
      farmUuid: farmId,
      workTypeId: HARVESTING_WORK_TYPE_ID,
      geoRegionShapeUuid: fieldListById[shapeRefId].geo_shape_object_uuid,
      geoShapeUuid: fieldListById[shapeRefId].geo_shape_uuid,
    });
  };

  useEffect(() => {
    if (showDropdown && !isRequestingWorkInfo) {
      const cb = (dateInfo) => {
        const workTypeIds = selectedWorkTypeIds;
        const hasWorkTypeIds = egWorkDetails.map((item) => item.workTypeId);
        const newWorkTypeIds = workTypeIds.filter((id) => hasWorkTypeIds.indexOf(id) < 0);

        if (newWorkTypeIds.length > 0) {
          const params = {
            farmId,
            shapeGroupId: fieldListById[shapeRefId].regionDetails.geo_region_uuid,
            shapeRefId,
            workTypeIds: newWorkTypeIds,
            ...dateInfo,
          };
          dispatch(getEGWorkedAcres(params));
        }
      };

      dispatch(getDateRangeInfo({ farmId }, cb));
    }
  }, [showDropdown, isRequestingWorkInfo, rangeId, selectedWorkTypeIds, isRequestingPlanPlannedToDate]);

  let isRequestingEgInfo = false;
  let hasEgList = false;
  let hasEgDetails = false;

  for (const item of egWorkDetails) {
    if (item.isRequesting) isRequestingEgInfo = true;
    if (item.payload.length > 0) hasEgList = true;
    if (!hasEgDetails) hasEgDetails = item.payload.filter((item) => egListById[item.equipment_group_uuid]).length > 0;
  }

  const workTypeListById = {};
  WORK_TYPE_LIST.forEach((item) => {
    if (item.list) {
      item.list.forEach((item) => (workTypeListById[item.work_type_id] = item.work_type));
    } else workTypeListById[item.work_type_id] = item.work_type;
  });

  return (
    <>
      {
        <Card.Body className={`field-item-body ${showDropdown ? "show" : "hide"}`}>
          <Row>
            {!hasEgList || !hasEgDetails || isRequestingEgInfo || isRequestingEg || isRequestingWorkInfo ? (
              <Col lg={10} md={10} sm={10} className="no-item-found">
                {isRequestingEgInfo || isRequestingEg || isRequestingWorkInfo ? "Loading..." : "No equipment groups found"}
              </Col>
            ) : (
              <Col lg={selectedPlanType === 2 ? 12 : 10} md={selectedPlanType === 2 ? 12 : 10} sm={selectedPlanType === 2 ? 12 : 10}>
                {egWorkDetails
                  .sort((a, b) => b.workTypeId - a.workTypeId)
                  .map((item, index) => {
                    const workTypeColor = WORK_TYPE_COLOURS[item.workTypeId];
                    if (item.payload.length === 0) return <React.Fragment key={index} />;
                    else
                      return (
                        <React.Fragment key={index}>
                          <Row className="field-title">
                            <Col className="m-auto">
                              <div className="splitter" style={{ background: workTypeColor }} />
                            </Col>
                            <div style={{ color: workTypeColor, borderColor: workTypeColor }} className="type">
                              {workTypeListById[item.workTypeId]}
                            </div>
                            <Col className="m-auto">
                              <div className="splitter" style={{ background: workTypeColor }} />
                            </Col>
                          </Row>
                          <CardDeck className="m-0">
                            {item.payload.map((item) => (
                              <EgCard key={item.equipment_group_uuid} egWorkDetail={item} egDetails={egListById[item.equipment_group_uuid]} />
                            ))}
                          </CardDeck>
                        </React.Fragment>
                      );
                  })}
              </Col>
            )}
            {selectedPlanType !== 2 && (
              <Col lg={2} md={2} sm={2} style={{ textAlign: "end" }}>
                {isCompleted ? (
                  <Button variant="danger" size="sm" className="btn-xs mark-completed" onClick={() => updateStatus(isCompleted)}>
                    Mark as Completed
                  </Button>
                ) : (
                  <Button variant="success" size="sm" className="btn-xs mark-active" onClick={() => updateStatus(isCompleted)}>
                    Mark as Active
                  </Button>
                )}
              </Col>
            )}
          </Row>
        </Card.Body>
      }
      {complete && <Modal.Confirm
        isOpen={complete}
        onConfirm={handleFieldWorkStatus}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        body={
          <>
            Are you sure to mark field <b>{currentFieldName}</b> as {isCompleted ? "completed" : "active"} ?
          </>
        }
        variant="info"
        confirmButton={{ variant: "info" }}
        onHide={() => setComplete(false)}
      />}
    </>
  );
};

export default memo(CardBody);
